export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";